<off-canvas-menu-body (hide)="close()"
                      class="fill"
                      offClickFilter=".off-canvas-close,[offCanvasMenuToggle]"></off-canvas-menu-body>